import { Box } from "@mui/material"
import { styled } from "@mui/material/styles"
import { MuiOtpInput } from "mui-one-time-password-input"
import { colors } from "../../theme/colors"

export const ContentContainer = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  flex: 1,
  textAlign: "center",
}

export const AuthTitle = {
  marginBottom: "20px",
  maxWidth: 250,
}

export const AuthSubtitle = {
  marginBottom: "50px",
  maxWidth: 250,
  fontWeight: 400,
}

export const CodeTitle = {
  marginBottom: "50px",
}

export const StyledMuiOtp = styled(MuiOtpInput, {
  shouldForwardProp: (props) => props !== "error",
})(({ error }: { error?: boolean }) => ({
  width: "288px",
  marginBottom: "16px",
  columnGap: "16px",
  "& .MuiInputBase-root": {
    "&::before": {
      borderColor: error ? "red" : "",
    },
    "&::after": {
      borderBottom: error ? "2px solid red" : "",
    },
  },
}))

export const RepeatCodeTitle = {
  fontWeight: 400,
}

export const ChangeNumberContainer = {
  width: "100%",
  margin: "auto 0 0 0",
  border: "1px solid",
  borderRadius: "8px",
  padding: "16px 0",
  borderColor: colors.paleGray,
}

export const ResendText = {
  display: "contents",
  fontSize: "15px",
  whiteSpace: "pre-line",
}

export const ChangeNumberText = {
  display: "contents",
  fontSize: "15px",
}

export const IconContainer = styled(Box)({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  marginTop: "auto",
})